import { useEffect, useRef } from 'react';

interface CountdownOverlayProps {
  value: number; // 3, 2, 1 → then 0 = "starting" phase
}

// VI-702: Figma-matching countdown. Just the number (3, 2, 1) over a dark
// backdrop — no boxes, no crosshair, single digit (not 03/02/01). Poppins 700.
const CountdownOverlay = ({ value }: CountdownOverlayProps) => {
  const digitRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = digitRef.current;
    if (!el || value === 0) return;
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;
    el.classList.remove('vi-countdown-pop');
    void el.offsetWidth;
    el.classList.add('vi-countdown-pop');
  }, [value]);

  return (
    <>
      <style>{`
        @keyframes vi-pop {
          0%   { transform: scale(1.5); opacity: 0; }
          40%  { opacity: 1; }
          100% { transform: scale(1);   opacity: 1; }
        }
        .vi-countdown-pop {
          animation: vi-pop 0.3s ease-out forwards;
        }
      `}</style>

      {/* Dark semi-transparent backdrop */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.50)',
          borderRadius: 'inherit',
        }}
      >
        {value > 0 ? (
          <span
            ref={digitRef}
            style={{
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 700,
              fontSize: 'clamp(4rem, 18vw, 8rem)',
              color: '#FFFFFF',
              lineHeight: 1,
              userSelect: 'none',
            }}
          >
            {value}
          </span>
        ) : (
          /* value === 0: WS pre-warm not yet resolved (rare on slow networks) */
          <span style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: '0.9rem',
            fontWeight: 500,
            color: 'rgba(255,255,255,0.85)',
            letterSpacing: '0.04em',
          }}>
            Recording…
          </span>
        )}
      </div>
    </>
  );
};

export default CountdownOverlay;
